import Factory from '../factory';

const schema = Factory.schema('team');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String);
attributes.prop('items').setType(Array);

export default schema;
